import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHero from 'tio-ui/components/page-hero';
import SectionHeader from 'tio-ui/components/section-header';
import FilterTabs from 'tio-ui/components/filter-tabs';
import type { FilterTab } from 'tio-ui/components/filter-tabs';
import { PhGraduationCap, PhStack } from 'ember-phosphor-icons';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';

const ROUTE_PREFIX = 'authenticated.questions-you-have.paying-for-college';

export default class PayingForCollegePage extends Component {
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get tabs(): FilterTab[] {
    return [
      {
        id: 'federal',
        label: this.intl.t('questions_you_have.types_of_student_loans.federal_aid'),
      },
      {
        id: 'private',
        label: this.intl.t('questions_you_have.types_of_student_loans.private_loans'),
      },
      {
        id: 'plus',
        label: this.intl.t('questions_you_have.types_of_student_loans.plus_loans'),
      },
    ];
  }

  get activeTab(): string {
    const name = this.router.currentRouteName ?? '';
    if (name === `${ROUTE_PREFIX}.private-loans`) return 'private';
    if (name === `${ROUTE_PREFIX}.plus-loans`) return 'plus';
    return 'federal';
  }

  setTab = (id: string) => {
    const route =
      id === 'private'
        ? `${ROUTE_PREFIX}.private-loans`
        : id === 'plus'
          ? `${ROUTE_PREFIX}.plus-loans`
          : `${ROUTE_PREFIX}.index`;
    this.router.transitionTo(route);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  <template>
    <VStack class="gap-8 pb-12">
      <PageHero
        @icon={{PhGraduationCap}}
        @title={{t "questions_you_have.paying_for_college.what_is_federal_loan_q"}}
        @subtitle={{t "questions_you_have.paying_for_college.what_is_federal_loan_a"}}
        @gradient="brand"
        @decoration="circles"
        @rounded="2xl"
      />

      <div>
        <SectionHeader
          @icon={{PhStack}}
          @title={{t "questions_you_have.types_of_student_loans.default"}}
          @iconClass="tio-fg-brand"
        />
        <FilterTabs
          @tabs={{this.tabs}}
          @activeId={{this.activeTab}}
          @onSelect={{this.setTab}}
          @activeClass="bg-indigo-600 text-white shadow-md"
          @showCounts={{false}}
          class="mb-6"
        />
        {{outlet}}
      </div>
    </VStack>
  </template>
}
